import { render } from "./PromptManagementTemplateForm.vue?vue&type=template&id=2a2e2c15&scoped=true"
import script from "./PromptManagementTemplateForm.vue?vue&type=script&lang=js"
export * from "./PromptManagementTemplateForm.vue?vue&type=script&lang=js"

import "./PromptManagementTemplateForm.vue?vue&type=style&index=0&id=2a2e2c15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2e2c15"]])

export default __exports__